<template>
  <div class="mall-home">
    <header class="home-head">
      <span
        class="brand"
        aria-hidden="true"
      ><i /></span>
      <button
        class="language"
        @click="$router.push('/language')"
      >
        <img
          src="../images/ban/lang.png"
          alt=""
        >{{ $t('shop.language') }} <span>▼</span>
      </button>
    </header>
    <nav class="shortcut-grid">
      <button
        v-for="(category, index) in categories"
        :key="category.id"
        @click="openCategory(category)"
      >
        <img
          :src="category.image || shortcutIcons[index]"
          :alt="category.name"
        >
        <span>{{ category.name }}</span>
      </button>
      <button @click="$router.push('/teamhis')">
        <img
          src="../images/ban/yao.png"
          alt=""
        >
        <span>{{ $t('shop.invite') }}</span>
      </button>
    </nav>
    <main>
      <h1>{{ $t('shop.dailyPush') }}</h1>
      <section class="goods">
        <button
          v-for="product in products"
          :key="product.id"
          class="good-card"
          @click="$router.push('/good/' + product.id)"
        >
          <img
            :src="product.image"
            :alt="product.title"
          >
          <span class="title">{{ product.title }}</span>
          <strong>{{ money(product.price) }}</strong>
          <del v-if="product.market_price">{{ money(product.market_price) }}</del>
        </button>
      </section>
      <button
        class="more"
        @click="$router.push('/goodList')"
      >
        {{ $t('shop.more') }}
      </button>
      <section class="why">
        <h2>{{ $t('shop.whyChooseUs') }}</h2>
        <article
          v-for="item in reasons"
          :key="item.title"
        >
          <img
            :src="item.icon"
            alt=""
          >
          <div>
            <h3>{{ item.title }}</h3><p
              v-for="line in item.lines"
              :key="line"
            >
              {{ line }}
            </p>
          </div>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';

export default {
    data() {
        return {
            categories: [],
            products: [],
            shortcutIcons: [
                require('../images/ban/up.png'),
                require('../images/ban/buying.png'),
                require('../images/ban/hunt.png')
            ]
        };
    },
    computed: {
        reasons() {
            return [
                { icon: require('../images/ban/advantages.png'), title: this.$t('shop.advantages'), lines: [this.$t('shop.factory'), this.$t('shop.skus')] },
                { icon: require('../images/ban/shipping.png'), title: this.$t('shop.orderingService'), lines: [this.$t('shop.processing'), this.$t('shop.tracking'), this.$t('shop.shipping')] },
                { icon: require('../images/ban/safe.png'), title: this.$t('shop.safePayment'), lines: [this.$t('shop.cardPayment'), this.$t('shop.noCardStorage')] },
                { icon: require('../images/ban/protection.png'), title: this.$t('shop.buyerProtection'), lines: [this.$t('shop.fullRefund'), this.$t('shop.partialRefund')] }
            ];
        }
    },
    mounted() {
        document.body.classList.add('mall-home-page');
        this.$parent.footer('index');
        Fetch('/shop/home', {}, null, true).then((res) => {
            this.categories = res.data.categories || [];
            this.products = res.data.products || [];
        });
    },
    beforeDestroy() {
        document.body.classList.remove('mall-home-page');
    },
    methods: {
        money(value) {
            return this.$formatPen(value);
        },
        openCategory(category) {
            this.$router.push({ path: '/goodList', query: { class_id: category.id, title: category.name } });
        }
    }
};
</script>

<style scoped>
.mall-home { min-height: 100vh; padding-bottom: calc(var(--app-bottom-menu-height) + var(--app-bottom-menu-gap) + 32px + env(safe-area-inset-bottom, 0px)); background: #f5f5f5; color: #333; }
.home-head { display: flex; height: 50px; justify-content: space-between; align-items: center; padding: 0 16px; background: #fff; }
.brand { position: relative; display: block; width: 34px; height: 34px; border-radius: 5px; background: #ee4d2d; }
.brand::before { position: absolute; top: 10px; left: 8px; width: 18px; height: 16px; border: 2px solid #fff; border-top: 0; border-radius: 2px; content: ''; }
.brand i { position: absolute; top: 4px; left: 12px; width: 10px; height: 8px; border: 2px solid #fff; border-bottom: 0; border-radius: 8px 8px 0 0; background: transparent; }
.language { display: flex; height: 32px; align-items: center; gap: 5px; padding: 0 10px; border: 1px solid #eee; border-radius: 4px; background: #fff; color: #555; font-size: 12px; }
.language img { width: 18px; height: 18px; }
.shortcut-grid { display: grid; grid-template-columns: repeat(4, 1fr); background: #fff; border-top: 1px solid #f2f2f2; }
.shortcut-grid button { display: flex; min-height: 92px; flex-direction: column; align-items: center; justify-content: center; gap: 8px; border: 0; border-right: 1px solid #f2f2f2; background: #fff; color: #555; font-size: 12px; }
.shortcut-grid button:last-child { border-right: 0; }
.shortcut-grid img { width: 38px; height: 38px; object-fit: contain; }
main { padding: 14px 10px 24px; }
h1 { margin: 0 4px 12px; color: #ee4d2d; font-size: 16px; font-weight: 500; }
.goods { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
.good-card { overflow: hidden; padding: 0 0 10px; border: 1px solid #eee; border-radius: 0; background: #fff; color: #333; text-align: left; }
.good-card img { width: 100%; height: 164px; object-fit: contain; }
.good-card .title { display: -webkit-box; min-height: 32px; margin: 9px 10px 3px; overflow: hidden; font-size: 12px; line-height: 16px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.good-card strong { display: block; margin: 0 10px; color: #ee4d2d; font-size: 14px; font-weight: 600; }
.good-card del { display: block; margin: 0 10px; color: #929aa3; font-size: 12px; }
.more { display: block; margin: 22px auto 16px; padding: 7px 22px; border: 1px solid #ee4d2d; border-radius: 4px; background: #fff; color: #ee4d2d; font-size: 12px; }
.why { overflow: hidden; border-radius: 0; background: #fff; margin-bottom: 50px; }
.why > h2 { margin: 0; padding: 12px; border-bottom: 1px solid #eee; background: #fff; color: #ee4d2d; font-size: 16px; font-weight: 500; }
.why article { display: flex; gap: 10px; padding: 16px 12px; border-bottom: 1px solid #e3e3e3; }
.why article > img { width: 28px; height: 28px; object-fit: contain; }
.why h3 { margin: 0 0 8px; color: #333; font-size: 14px; font-weight: 600; }
.why p { margin: 0 0 5px; color: #777; font-size: 12px; line-height: 16px; }
</style>
